import React, { useEffect, memo } from 'react';

import { Container } from '../../../../symphony';

import { SlDataService } from '../../services/sl-data.service';
import { IOutput } from '../../../../shared/public/SlCodeEditorComponents/types/types';
import { OutputIframe } from '../../../../shared/public/SlCodeEditorComponents/OutputIframe/OutputIframe';
import { useIFrameSrc } from '../../../../shared/public/SlCodeEditorComponents/utils/hooks';
import { lePlaygroundContext } from '../../global-constants';

export interface OutputIframeContainerProps {
	value: IOutput;
	isWeb?: boolean;
	iframeHeight?: number;
	isTIYWidget?: boolean;
}

export const OutputIframeContainer: React.FC<OutputIframeContainerProps> = memo(
	({
		value, isWeb, iframeHeight, isTIYWidget,
	}) => {
		const { outputConsole$ } = Container.take(
			lePlaygroundContext.value,
			SlDataService,
		);

		const iframeSrc = useIFrameSrc();

		useEffect(() => {
			const receiveIframeMessage = (e) => {
				if (e.origin !== iframeSrc) {
					return;
				}
				const data = e.data?.console;

				if (data) {
					outputConsole$.next(
						outputConsole$.value
							? [...outputConsole$.value, data]
							: [data],
					);
				}
			};

			window.addEventListener('message', receiveIframeMessage, false);

			return () => {
				window.removeEventListener(
					'message',
					receiveIframeMessage,
					false,
				);
			};
		}, []);

		// eslint-disable-next-line
		const text = value ? new String(value.output || '') : ''; // for rendering when text is not changed

		useEffect(() => {
			const iframe: any = document.getElementById(
				'output-frame',
			) as HTMLIFrameElement;
			const iframeDoc = iframe.contentWindow;
			outputConsole$.next(null);

			if (iframeDoc) {
				iframeDoc.postMessage(isWeb ? text : value?.output, '*');
			}
		}, [text]);

		return <OutputIframe isTIYWidget={isTIYWidget} iframeHeight={iframeHeight} value={value} />;
	},
);
